<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    :drawerStyle="{ 'padding-bottom': '25px' }"
    style="  overflow: auto; padding-bottom: 53px"
  >
    <template slot="title">
      <div style="width: 100%">
        <span>{{ title }}</span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="标签组名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :maxLength="28"
            placeholder="请输入标签组名称"
            v-decorator="['name', validatorRules.name]"
          />
        </a-form-item>
        <a-form-item label="次序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            id="number"
            :min="1"
            :max="100"
            v-decorator="['sort', validatorRules.listnum]"
          />
        </a-form-item>
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group
            v-decorator="[
              'type',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择类型！'
                  }
                ]
              }
            ]"
          >
            <a-radio :value="1">
              群
            </a-radio>
            <a-radio :value="2">
              渠道
            </a-radio>
            <!--            <a-radio :value="3">-->
            <!--              话术-->
            <!--            </a-radio>-->
          </a-radio-group>
        </a-form-item>
        <div
          v-for="(item, index) in tagList"
          :key="index"
          style="position: relative;"
        >
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="标签"
                :labelCol="{ span: 10 }"
                :wrapperCol="{ span: 12 }"
              >
                <a-input
                  type="text"
                  require="true"
                  placeholder="请输入标签名称"
                  v-decorator="[
                    'tagName' + (index + 1),
                    {
                      ...validatorRules.tagName,
                      initialValue: item.name
                    }
                  ]"
                  style="width: 100%; margin-right: 20px"
                  @blur="changeInput(item.name)"
                  @change="nameChange($event, index)"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                label=" "
                :colon="false"
                :labelCol="{ span: 0 }"
                :wrapperCol="{ span: 14 }"
                class="tag-sort"
              >
                <a-input-number
                  :min="1"
                  :max="100"
                  v-decorator="[
                    'tagNum' + (index + 1),
                    {
                      ...validatorRules.tagNum,
                      initialValue: item.sort
                    }
                  ]"
                  style="width: 50%; margin-right: 20px"
                  @change="numChange($event, index)"
                />
                <a-button @click="deleteList(index)"> 删除 </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-button type="primary" style="margin-left: 80px" @click="addList()">
          添加
        </a-button>
      </a-form>

      <!-- <a-form-model ref="tagList">
        <a-form-model-item
          label="标签"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-for="(item, index) in tagList"
          :key="index"
        >
          <a-input
            type="text"
            v-model="item.name"
            placeholder="请输入标签名称"
            style="width: 30%; margin-right: 20px"
          />

          <a-input-number
            v-model="item.sort"
            :min="1"
            :max="100"
          />
          <a-button style="margin: 0 20px" @click="deleteList(index)"> 删除 </a-button>
        </a-form-model-item> 
      </a-form-model> -->
      <!-- <a-button type="primary" style="margin-left: 80px" @click="addList()"> 添加 </a-button> -->
    </a-spin>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import { getAction } from '@/api/manage';
import { addSystemTag, editSystemTag } from '@/api/api';

export default {
  name: 'systemTagModal',
  data() {
    return {
      tagLength: 1,
      drawerWidth: 700,
      modaltoggleFlag: true,
      disableSubmit: false,
      validatorRules: {
        name: {
          rules: [{ required: true, message: '请输入标签组名称!' }]
        },
        listnum: {
          rules: [{ required: true, message: '请输入标签次序号!' }]
        },
        tagName: {
          rules: [{ required: true, message: '请输入标签名称!' }]
        },
        tagNum: {
          rules: [{ required: true, message: '请输入标签次序号!' }]
        }
      },
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      picUrl: '',
      tagList: [{ name: '', sort: '' }],
      //标识
      flag: '',
      tagFlag: '',
      //1.编辑标签 2.编辑标签组
      type: 1,
      disabled: false,
      url: {
        queryGroupTagById:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tagmanage/queryGroupTagById',
        tagNameIsExists:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tag/tagNameIsExists',
        getAllGroupName:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/tagmanage/queryTagNodeNamesByGroupId'
      },
      flag: '',
      tagFlag: ''
    };
  },
  created() {
    // getAction(this.url.getAllGroupName, {}).then((res) => {
    //   this.tagOperation = res.result;
    //   console.log(this.tagOperation);
    // });
    console.log(9999);
  },

  methods: {
    changeInput(value) {
      //同一个标签组内标签的名称不能重复
      const that = this;
      let result = that.decideIsExists();
      if (result > 0) {
        that.$message.error('标签名称不能重复');
        return false;
      }
    },

    nameChange(e, index) {
      console.log(this.numIndex);
      this.tagList[index].name = e.target.value;
    },
    numChange(e, index) {
      console.log(e);

      this.tagList[index].sort = e;
    },
    testData() {
      const that = this;
      //新增 编辑标签组
      let count = 0;
      let tagResult = that.decideIsExists();

      if (tagResult > 0) {
        that.$message.error('标签名称不能重复');
        return false;
      }

      for (let i in this.tagList) {
        if (this.tagList[i].name != '') {
          count = 1;
          break;
        }
      }
      if (count <= 0) {
        this.$message.error('请添加子标签!');
        return false;
      }
    },

    decideIsExists() {
      //校验同一个标签组是否存在同名标签
      const that = this;
      let result = 0;
      if (that.tagList.length > 1) {
        for (let i = 0; i < this.tagList.length; i++) {
          //空标签不跳过查重
          if (that.tagList[i].name == '') {
            continue;
          }
          for (let j = i + 1; j < this.tagList.length; j++) {
            if (this.tagList[i].name == this.tagList[j].name) {
              result = 1;
              return result;
            }
          }
        }
      }
      return result;
    },
    addList() {
      this.tagList.push({ name: '', sort: '' });
    },
    deleteList(index) {
      this.tagList.splice(index, 1);
    },
    addTagBtn(e) {
      console.log('点击增加标签:' + e);
      this.tagLength += 1;
    },
    add() {
      this.tagList = [{ name: '', sort: '' }];
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (record.id) {
        getAction(this.url.queryGroupTagById, {
          id: record.id
        }).then(res => {
          if (res.success) {
            this.tagList = res.result.tags;
          }
          //判断是否是编辑标签组
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model, 'name', 'sort', 'type'));
          });
        });
      } else {
        //判断是否是编辑标签组
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'name', 'sort', 'type'));
        });
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    moment,
    handleSubmit() {
      const that = this;
      let result = that.testData();
      if (result != undefined && !result) {
        return false;
      }
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(that.model, values);
          let obj;
          formData.tags = this.tagList;
          formData.sort = that.model.sort;
          formData.type = that.model.type;
          if (!that.model.id) {
            obj = addSystemTag(formData);
          } else {
            obj = editSystemTag(formData);
          }
          obj
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              this.disabled = false;
              that.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.disabled = false;
      this.close();
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.ant-form-item {
  margin-bottom: 20px;
}
</style>
